<template>
<div>
    <!-- modal -->
    <b-modal id="plantVarietyNoteFormModal" centered size="lg" no-close-on-backdrop ref="plantVarietyNoteFormModal" :title="$t('plantVarietyNote.info')" @close="clear()" :cancel-title=" $t('others.cancel_title')" :ok-title=" $t('others.ok_title')" cancel-variant="outline-secondary" @ok.prevent="addOrUpdate">
        <validation-observer ref="infoRules" tag="form">
            <b-row>
                <b-col class="col-lg-12">
                    <b-form>
                        <validation-provider :name="$t('plantVarietyNote.type')" #default="{ errors }" :rules="{ excluded: 0 }">
                            <label for="plantVariety-note-type-input">{{ $t('plantVarietyNote.type') }}</label>
                            <b-form-select v-model="noteTypeSelect" value-field="id" text-field="name" size="sm" :options="noteTypeOption" />
                            <b-form-invalid-feedback :state="errors.length > 0 ? false : null">
                                {{ errors[0] }}
                            </b-form-invalid-feedback>
                        </validation-provider>
                    </b-form>
                </b-col>
            </b-row>
            <b-row>
                <b-col class="col-lg-6 mt-1">
                    <b-form>
                        <label for="plantVariety-note-employee-input">{{ $t('plantVarietyNote.employee') }}</label>
                        <b-form-select v-model="employeeSelect" value-field="id" text-field="name" size="sm" :options="employeeOption" />
                    </b-form>
                </b-col>
                <b-col class="col-lg-6 mt-1">
                    <b-form>
                        <label for="plantVariety-note-date-input">{{ $t('plantVarietyNote.date') }}</label>
                        <CustomDatePicker :datePickerValidateOption="0" v-model="date"></CustomDatePicker>
                    </b-form>
                </b-col>
            </b-row>
            <b-row>
                <b-col class="col-md-12">
                    <label for="plantVariety-note">{{ $t('plantVarietyNote.note') }}</label>
                    <validation-provider #default="{ errors }" :name="$t('plantVarietyNote.note')" rules="required">
                        <b-form-textarea id="plantVariety-note" :placeholder="$t('plantVarietyNote.note')" v-model="note" rows="9" maxlength="250" :state="errors.length > 0 ? false : null" />
                        <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                </b-col>
            </b-row>
        </validation-observer>
    </b-modal>
</div>
</template>

<script>
export default {
    props: {
        getPlantVarietyNoteList: {
            type: Function
        },
        getPlantVarietyList: {
            type: Function
        }
    },
    data() {
        return {
            id: 0,
            plantVarietyId: 0,
            noteTypeOption: [],
            noteTypeSelect: 0,
            employeeOption: [],
            employeeSelect: 0,
            date: null,
            note: '',
        }
    },
    methods: {
        showInfo(id, plantVarietyId) {
            this.$refs['plantVarietyNoteFormModal'].show()
            this.id = id
            this.plantVarietyId = plantVarietyId
            const data = {
                id: this.id
            }
            const controller = {
                name: 'PlantVarietyNote'
            }
            const payload = {
                data: data,
                controller: controller
            }
            this.$store.dispatch('moduleAuth/getInfo', payload).then((response) => {
                if (response.data.resultStatus == true) {
                    this.note = response.data.plantVarietyNote.note
                    this.date = response.data.plantVarietyNote.date
                    this.noteTypeSelect = response.data.plantVarietyNote.plantVarietyNoteTypeId
                    this.noteTypeOption = response.data.plantVarietyNoteTypeList
                    this.noteTypeOption.splice(0, 0, this.$nullSelected())
                    if (response.data.plantVarietyNote.employeeId > 0) {
                        this.employeeSelect = response.data.plantVarietyNote.employeeId;
                    } else {
                        this.employeeSelect = localStorage.getItem('EmployeeId');
                    }

                    this.employeeOption = response.data.employeeList
                    this.employeeOption.splice(0, 0, this.$nullSelected())
                } else {
                    this.$bvModal.hide('plantVarietyNoteFormModal')
                    this.$WarningAlert(response.data.resultMessage)
                }
            })
        },
        clear() {
            this.noteTypeSelect = 0
            this.noteTypeOption = []
            this.employeeSelect = 0
            this.employeeOption = []
            this.date = null
            this.note = ''
        },
        addOrUpdate() {
            const data = {
                id: this.id,
                plantVarietyId: this.plantVarietyId,
                note: this.note,
                date: this.date,
                plantVarietyNoteTypeId: this.noteTypeSelect,
                employeeId: this.employeeSelect
            }
            const controller = {
                name: 'PlantVarietyNote'
            }
            const payload = {
                data: data,
                controller: controller
            }
            this.$refs.infoRules.validate().then(success => {
                if (success) {
                    this.$store.dispatch('moduleAuth/save', payload).then((response) => {
                        if (response.data.resultStatus == true) {
                            this.$bvModal.hide('plantVarietyNoteFormModal')
                            this.getPlantVarietyNoteList()
                            this.$SaveAlert()
                            this.getPlantVarietyList()
                        } else {
                            this.$WarningAlert(response.data.resultMessage)
                        }
                    })
                }
            })
        }
    },
}
</script>

<style lang="scss">
[dir=ltr] .modal-header .close {
    margin: -0.4rem -0.4rem -0.8rem auto;
}

[dir] label {
    margin-bottom: 0.2857rem;
    font-weight: bold;
}

.modal .modal-content {
    overflow: visible;
    margin-bottom: auto;
}

[dir] .invalid-tooltip {
    padding: 0.4rem 0.775rem !important;
    margin-top: -1.5rem !important;
    background-color: #ea5455 !important;
    border-radius: 0.358rem !important;
    left: 20px !important
}

.datepickerStyle {
    max-height: 2.2em;
    font-family: fangsong;
}
</style>
